import { connect } from "react-redux";
import { AiOutlineRight } from "react-icons/ai";
import donationBanner from "../../assets/donation_banner.png";
import firebase from "firebase/compat/app";
import { useHistory } from "react-router-dom";
import marketTypes from "../../redux/Market/market.types";
import { startGetCause } from "../../redux/Market/market.actions";
import { useTranslation } from "react-i18next";

const DonationBanner = ({
    highlightedCause,
    dispatchStartLoader,
    dispatchStartGetCause,
}) => {
    const history = useHistory();

    const { t } = useTranslation();

    const fallbackCauseId = 449;

    const handleDonationBannerClick = () => {
        dispatchStartLoader();
        dispatchStartGetCause(highlightedCause?.cause?.id || fallbackCauseId);
        firebase.analytics().logEvent("clicou_doar_causa_destaque", {
            id: highlightedCause?.cause?.id || fallbackCauseId,
        });
        history.push(`/cause-detail/${highlightedCause?.cause?.id || fallbackCauseId}`);
    }

    const htmlCauseDescription = {__html: highlightedCause?.description || t("cause.default_highlighted_description")};

    return (
        <button
        type="button"
        onClick={handleDonationBannerClick}
        className={`
            btn-effects
            relative
            text-start
            flex
            rounded-[20px]
            bg-[url(${donationBanner})]
            bg-cover
            bg-center
            bg-no-repeat
            text-white
            w-full
            sm:w-[80%]
            items-center
            mx-auto
            -mt-16
            mb-6
            h-[56px]
            px-[11px]
        `}>
            <div className="grow">
                <h2 className="text-[16px] sm:text-[18px] line-clamp-1 font-VolkswagenMedium">
                    {highlightedCause?.title || t("cause.default_highlighted_title")}
                </h2>
                <p className="text-[12px] sm:text-[14px] line-clamp-1 font-OpenSansRegular" dangerouslySetInnerHTML={htmlCauseDescription} />
            </div>
            <div className="text-primary rounded-[12px] bg-white max-h-[36px] max-w-[36px] min-w-[36px] min-h-[36px] flex items-center justify-center">
                <AiOutlineRight size={13} />
            </div>
        </button>
    );
}

const mapStateToProps = ({ market }) => ({
    highlightedCause: market.highlightedCause,
});

const mapDispatchToProps = (dispatch) => ({
    dispatchStartGetCause: (id) => dispatch(startGetCause(id)),
    dispatchStartLoader: () => dispatch({ type: marketTypes.START_LOADER }),
});

export default connect(mapStateToProps, mapDispatchToProps)(DonationBanner);